export const GeneralSettingsTestIds = {
  generalSettingsContainer: 'general_settings_container',
  buttonEditAvatar: 'button_editAvatar',
  iconKickMember: 'icon_kick_member',
  buttonSaveGeneral: 'button_save_general'
} as const;
